import { action } from 'typesafe-actions';
import { studentDetailActionTypes as act } from './actionTypes';

export function addStudentDetail(student) {
  return action(act.SET_STUDENT_DETAIL, { student });
}

export function studentIdEnable(student) {
  return action(act.SET_STUDENT_ID_ENABLE, { student });
}

export function updateStudentIdEnable(student) {
  return action(act.UPDATE_STUDENT_ID_ENABLE, { student });
}

export function clearStudentId(fund) {
  return action(act.CLEAR_STUDENT_ID, { fund });
}
